import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

export const useDeleteContentInTextSet = () => {
  const deleteTextSetContent = useCallback((payload) => {
    const requestParams = {
      method: "DELETE",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    };
    return new Request(
      `${MONOLITH_ORIGIN}/api/v3/content-membership/`,
      requestParams,
    );
  }, []);

  return useRestMutation(deleteTextSetContent);
};

export default useDeleteContentInTextSet;
